import React from 'react'
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {convertToCurrencyFormat} from "../OwnQueue/ownQueueUtility";
import {DISPLAY_STATUS} from "./ownCatalogConstants";
import {renderCatalogDetail} from "../../LoanLibrary/loanLibraryCatalogUtilities";
import {CatalogItemImage} from "../../LoanLibrary/LoanLibraryCatalog/CatalogItemImage";
import {getLoanLibraryMediaFormatTextByValue} from "../../LoanLibrary/loanLibraryConstants";

interface OwnResultsRowProps {
    ownResource: Record<string, any>;
    canManageOwnCatalogItems: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
}

export const OwnResultsRow = ({
                                  ownResource,
                                  canManageOwnCatalogItems,
                                  handleAddToQueue,
                                  handleEdit,
                              }: OwnResultsRowProps) => {

    const handleClickEdit = () => handleEdit(ownResource.id);
    const handleClickAddToQueue = () => handleAddToQueue(ownResource.id);

    return (
        <div className="catalog-item" id={ownResource.catalogNumber}
             data-testid={ownResource.catalogNumber}>
            <div className="catalog-item__title-row">
                <h3 id={`title${ownResource.id}`}>
                    {ownResource.title}
                </h3>
                <div className="catalog-item__title-actions">
                    <ButtonLinkStyle
                        label="Add to Queue"
                        name={`btnAddQueue${ownResource.id}`}
                        onClick={handleClickAddToQueue}
                    />
                </div>
            </div>

            <div className="catalog-item__details-row">
                <CatalogItemImage
                    imageUrl={ownResource.productImageUrl as string | null | undefined}
                    productName={ownResource.title}
                />
                <div className="catalog-item__info">
                    {renderCatalogDetail(ownResource.catalogNumber, "Catalog Number")}
                    {renderCatalogDetail(getLoanLibraryMediaFormatTextByValue(ownResource.objectType), "Object Type")}
                    {renderCatalogDetail(ownResource.description, "Description", {enableLinkParsing: true})}
                    {renderCatalogDetail(ownResource.orderLimit, "Order Limit")}
                    {canManageOwnCatalogItems && renderCatalogDetail(convertToCurrencyFormat(ownResource.cost), "Cost")}
                    {renderCatalogDetail(ownResource.fileLink, "File Link", {enableLinkParsing: true})}
                    {renderCatalogDetail(ownResource.keywords, "Keywords/Tags")}
                    {canManageOwnCatalogItems && ownResource.availabilityStatus === DISPLAY_STATUS.Disabled &&
                        renderCatalogDetail("Yes", "Is For Internal Use")
                    }
                    {
                        canManageOwnCatalogItems &&
                        <div className="catalog-item__edit-link">
                            <ButtonLinkStyle
                                label="Edit Item"
                                name={`btnEdit${ownResource.id}`}
                                onClick={handleClickEdit}
                            />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}
